import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';
import {ROUTE_REPORT_HOSPITAL_RCPA} from '../../RoutePathConstant';
import {authLoader} from '../../loader';

const HospitalRCPAReport = lazy(() =>
  import('../../../screens/RCPA-HospitalRCPAReport')
    .then(module => ({default: module.HospitalRCPAReport})));

const RCPA_HospitalRCPAReportNavigation = [
  {
    path: ROUTE_REPORT_HOSPITAL_RCPA,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <HospitalRCPAReport />
      </Suspense>
    ),
  },
];

export default RCPA_HospitalRCPAReportNavigation;
